var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box',{ref:_vm.boxRef,attrs:{"customer":true,"autoLoad":true,"title":"万里牛仓库","width":800,"index":0,"moduleName":"sourcebill","store":_vm.store,"selectType":"radio"},on:{"hide":_vm.hide,"submit":_vm.submit,"boxdataload":_vm.boxdataload}})
}
var staticRenderFns = []

export { render, staticRenderFns }